@if (isAdvancedSearchApplied()) {
  <app-context-menu-item
    [withCheckOption]="true"
    [close]="true"
    title="All results"
  icon="sapphire-search"
    [active]="filterKey === 'search_results'"
    (execute)="selectFilter('search_results')"
  />
}

<!-- Handoff, 7 October: the fourth panel's collection dropdown reads "Workbooks", not "Sheets".
     The SIDEBAR keeps "Sheets" — `devdoc/specs/sheets.md` names it there, and this dropdown already
     holds eight collections to the sidebar's six, so the two were never the same list. -->
<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Workbooks"
  icon="sapphire-sheets"
  data-testid="sheets-panel-workbooks"
  [active]="filterKey === 'all_sheets'"
  (execute)="selectFilter('all_sheets')"
/>

<!-- SBUX-1043: second in the handoff's dropdown, between Workbooks and Flagged. A rolling week, as
     Slides has Recent, rather than the handoff's count of 20 (Oleg, 2026-10-09). -->
<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Recent"
  icon="sapphire-recent"
  data-testid="sheets-panel-recent"
  [active]="filterKey === 'recent'"
  (execute)="selectFilter('recent')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Flagged"
  icon="sapphire-flagged"
  [active]="filterKey === 'flagged'"
  (execute)="selectFilter('flagged')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Follow Up"
  icon="sapphire-follow-up"
  [active]="filterKey === 'followed'"
  (execute)="selectFilter('followed')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Snoozed"
  icon="sapphire-snooze"
  [active]="filterKey === 'snoozed'"
  (execute)="selectFilter('snoozed')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  [title]="S['Templates']"
  icon="sapphire-template"
  data-testid="sheets-panel-templates"
  [active]="filterKey === 'templates'"
  (execute)="selectFilter('templates')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Archive"
  icon="sapphire-archive"
  [active]="filterKey === 'archived'"
  (execute)="selectFilter('archived')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Trash"
  icon="sapphire-trash"
  [active]="filterKey === 'deleted'"
  (execute)="selectFilter('deleted')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Folders"
  icon="sapphire-folders"
  [active]="filterKey === 'all_sheetFolders'"
  (execute)="selectFilter('all_sheetFolders')"
/>
